import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const Footer = () => {
  return (
    <footer 
      className="text-white py-4"
      style={{ 
        backgroundColor: '#212529',
        padding: '2rem 0'
      }}
    >
      <Container>
        <Row className="justify-content-center">
          <Col className="text-center">
            <p 
              className="mb-0"
              style={{ margin: 0 }}
            >
              &copy; 2024 Altogroup. All rights reserved. License: SC251038701
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
